import { colors } from '../constants/colors';
import type { ErrorIconVariant } from '../types';

export const errorMessage = {
  iconVariant: { name: 'circle-exclamation2' as ErrorIconVariant, color: colors.jlMoneyRed },
  backgroundColor: 'transparent',
  textColor: colors.jlMoneyRed,
  padding: '4px 0px',
  icon: true,
};
